import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed } from 'vue';
import { Link } from '@inertiajs/vue3';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ResponsiveNavLink',
    props: {
        href: {},
        active: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const classes = computed(() => props.active
            ? 'block w-full ps-3 pe-4 py-2 border-l-4 border-indigo-400 text-start text-base font-medium text-indigo-700 bg-indigo-50 focus:outline-none focus:text-indigo-800 focus:bg-indigo-100 focus:border-indigo-700 transition duration-150 ease-in-out'
            : 'block w-full ps-3 pe-4 py-2 border-l-4 border-transparent text-start text-base font-medium text-gray-600 hover:text-gray-800 hover:bg-gray-50 hover:border-gray-300 focus:outline-none focus:text-gray-800 focus:bg-gray-50 focus:border-gray-300 transition duration-150 ease-in-out');
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Link), {
                href: __props.href,
                class: _normalizeClass(classes.value)
            }, {
                default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "default")
                ]),
                _: 3
            }, 8, ["href", "class"]));
        };
    }
});
